import React, { useState, useEffect } from 'react';
import { Checkbox, Typography } from '@mui/material';
import useSettings from '../../hooks/useSettings';

const ConsentBoxes: React.FC<{ onCheckAll: (checked: boolean) => void }> = ({ onCheckAll }) => {
    const { showAcknowledgments, acknowledgements } = useSettings();
    const [consentChecked, setConsentChecked] = useState<boolean[]>([]);

    // Update the checkboxes' states based on the acknowledgements array
    useEffect(() => {
        if (Array.isArray(acknowledgements)) {
            setConsentChecked(new Array(acknowledgements.length).fill(false));
        }
    }, [acknowledgements]);

    // Check if all checkboxes are checked
    useEffect(() => {
        if (consentChecked.length > 0) {
            const allChecked = consentChecked.every(Boolean);
            onCheckAll(allChecked);
        }
    }, [consentChecked, onCheckAll]);

    const handleCheckboxChange = (index: number) => {
        const updatedConsentChecked = [...consentChecked];
        updatedConsentChecked[index] = !updatedConsentChecked[index];
        setConsentChecked(updatedConsentChecked);
    };

    // Handle empty or null acknowledgements
    if (!showAcknowledgments || (showAcknowledgments && (acknowledgements == null || acknowledgements.length === 0))) {
        // Signal that all checkboxes are considered checked if there are no acknowledgments
        useEffect(() => {
            onCheckAll(true);
        }, []);

        return <Typography variant="h6">No agreement of terms required.</Typography>;
    }

    return (
        <div className="consent-boxes">
            {Array.isArray(acknowledgements) && acknowledgements.map((ack, index) => (
                <Typography key={index} variant="body1">
                    <Checkbox
                        checked={consentChecked[index] || false}
                        onChange={() => handleCheckboxChange(index)}
                        disabled={!showAcknowledgments}
                    />
                    {ack}
                </Typography>
            ))}
        </div>
    );
};

export default ConsentBoxes;
